import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    padding: '20px 25px',
    backgroundColor: theme.palette.grey[100]
  },
  label: {
    color: theme.palette.text.secondary
  },
  value: {
    fontWeight: 600,
    textAlign: 'right'
  }
}))
